import styled from 'styled-components'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'
import Button from 'components/UI/Button/Button'
import FormInput from 'components/UI/FormInput/FormInput'

export const Wrapper = styled.div`
  ${fonts.libreBaskerville};
  position: relative;
  background-image: linear-gradient(
    to right,
    ${colors.mediumPurple} 0%,
    ${colors.darkPurple} 100%
  );
  padding: 50px 25px 35px 25px;
  max-width: 430px;
  margin: auto auto;
  border-radius: 20px;
`

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  margin-top: 20px;
`

export const CardDetails = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 8px 12px;
`

export const Heading = styled.div`
  font-size: 24px;
  text-align: center;
  margin-bottom: 25px;
`

export const Title = styled.span`
  color: ${colors.pink};
`

export const MessageText = styled.span`
color: ${colors.darkPurple};
`

export const Price = styled.span`
  color: ${colors.darkPurple};
  padding-left: 10px;
`

export const PriceStrikethrough = styled(Price)`
  text-decoration: line-through;
`

export const DiscountMessage = styled.div`
  color: ${colors.darkPurple};
  font-size: 15px;
`

export const Coupon = styled.div`
  display: flex;
  align-items: center;
`

export const Input = styled.input`
  flex-grow: 1;
  height: 30px;
  margin-right: 20px;
  border-radius: 5px;
  border: 1px solid #aaa;
  padding: 4px 8px;
`

export const StyledFormInput = styled(FormInput)`
  margin-right: 20px;
  margin-bottom: -10px;
`

export const DismissButton = styled(Button)`
  position: absolute;
  top: 10px;
  right: 10px;
`

export const Message = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  color: ${colors.white};
  font-size: 22px;
  text-align: center;
  & :first-child {
    width: 100%;
    margin-bottom: 20px;
  }
`

export const StyledLabel = styled.label`
  margin-bottom: 20px;
  font-size: 14px;
  margin-right: 20px;
`

export const CardDetailsRow = styled.div`
  display: flex;
`

const CardDetailsElement = styled.div`
  background-color: white;
  padding: 6px 12px;
  border-radius: 9px;
  margin-top: 2px;
  margin-right: 20px;
  box-shadow: 1px 1px 3px rgba(0,0,0,0.2);
`

export const CardDetailsNumber = styled(CardDetailsElement)`
  width: 202px;
`

export const SecurityCode = styled(CardDetailsElement)`
  width: 64px;
`

export const ExpiryDate = styled(CardDetailsElement)`
  width: 95px;
`

export const PostalCode = styled(CardDetailsElement)`
  width: 116px;
`

export const FormContainer = styled.div`
  width: 361px;
  margin: 0 auto;
`
